// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1z6T_","options":"AnswerScale_options__h4JIc","selected":"AnswerScale_selected__2zid-"};